import * as React from "react";
import { useEffect } from "react";
import "./searchViewStyles.css";
import { useTranslation } from "react-i18next";
import { useFocusable } from "../../../utils/Helpers";
import { focusManager } from "../../../utils/Focus";
export var SearchInputView = function (_a) {
    var phrase = _a.phrase, setPhrase = _a.setPhrase, verticalContainer = _a.verticalContainer;
    var t = useTranslation().t;
    var clearButtonRef = useFocusable({
        group: "searchClear",
        index: 0,
        onKeyDown: function () { return setPhrase(""); },
    });
    useEffect(function () {
        focusManager.registerGroup({
            name: "searchClear",
            position: 5,
            itemHeight: 240,
            verticalContainer: verticalContainer,
        });
    }, [verticalContainer]);
    return (React.createElement("div", { className: "search-input-container", id: "search-input-container" },
        React.createElement("p", { className: "search-text" },
            t("search.search"),
            " |"),
        React.createElement("div", { className: "search-input" }, phrase),
        React.createElement("div", { tabIndex: 0, className: "clear-btn", ref: clearButtonRef }, t("search.clear"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/search/SearchInputView.tsx
// module id = 164
// module chunks = 1